import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import {
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Divider
} from '@mui/material'
import { makeStyles } from '@mui/styles'
import {
  BookmarkBorder as BookmarkIcon,
  PersonOutline as ProfileIcon,
  ExitToApp as LogoutIcon
} from '@mui/icons-material'
import useLogout from '../../../hooks/useLogout'
import { routes } from '../../../router/routes'
import { useAlert } from '../../../hooks'
import ConfirmDialog from '../../../components/confirm-dialog'

const useStyles = makeStyles(({ spacing, shadows, palette, typography }) => ({
  profileMenu: {
    '& .MuiPaper-root': {
      borderRadius: spacing(1),
      marginTop: spacing(1),
      minWidth: 200,
      boxShadow: shadows[8]
    }
  },
  navButton: {
    textTransform: 'none',
    borderRadius: spacing(1),
    padding: `${spacing(1)} ${spacing(2)}`,
    color: palette.text.primary,
    fontWeight: typography.fontWeightMedium,
    minHeight: 40
  }
}))

export const PaidConsumerProfileMenu = ({ anchorEl, open, onClose }) => {
  const classes = useStyles()
  const { logout } = useLogout()
  const { enqueueMsg } = useAlert()
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false)

  const handleLogoutClick = () => {
    setShowLogoutConfirm(true)
    onClose()
  }

  const handleLogout = async () => {
    try {
      await logout(routes.login.path)
    } catch (error) {
      enqueueMsg('Unable to logout', 'error')
    }
  }

  return (
    <>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={onClose}
        className={classes.profileMenu}
        disableScrollLock
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem
          data-test='paid-consumer-profile-menu-bookmarks'
          component={Link}
          to={routes.bookmarks.path}
          onClick={onClose}
          className={classes.navButton}
        >
          <ListItemIcon>
            <BookmarkIcon />
          </ListItemIcon>
          <ListItemText>Bookmarks</ListItemText>
        </MenuItem>

        <MenuItem
          data-test='paid-consumer-profile-menu-my-profile'
          component={Link}
          to={routes.profile.path}
          onClick={onClose}
          className={classes.navButton}
        >
          <ListItemIcon>
            <ProfileIcon />
          </ListItemIcon>
          <ListItemText>My Profile</ListItemText>
        </MenuItem>

        <Divider />

        <MenuItem
          data-test='paid-consumer-profile-menu-logout'
          onClick={handleLogoutClick}
          className={classes.navButton}
        >
          <ListItemIcon>
            <LogoutIcon />
          </ListItemIcon>
          <ListItemText>Sign Out</ListItemText>
        </MenuItem>
      </Menu>

      <ConfirmDialog
        name='confirm-logout'
        title='Are you sure you want to logout?'
        open={showLogoutConfirm}
        onClose={() => setShowLogoutConfirm(false)}
        onConfirm={handleLogout}
      />
    </>
  )
}
